import React, { useEffect, useState } from 'react';
import { Award, Loader2, TrendingUp, ArrowDownLeft, ArrowUpRight, ShieldCheck } from 'lucide-react';
import AdminLayout from '../../components/AdminLayout';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authCfg = () => {
  const token = localStorage.getItem('c24_token') || localStorage.getItem('c24_admin_token');
  return { withCredentials: true, headers: token ? { Authorization: `Bearer ${token}` } : {} };
};

const AdminRewards = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`${API}/admin/rewards-transactions`, authCfg())
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false));
  }, []);
  return (
    <AdminLayout title="Rewards & Loyalty">
      {loading ? (
        <div className="text-center py-16"><Loader2 className="w-6 h-6 animate-spin mx-auto text-neutral-400" /></div>
      ) : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
            <Stat label="Total earned" value={`${data.summary.total_earned.toLocaleString('en-IN')} pts`} icon={ArrowDownLeft} color="#D97706" bg="#FEF3C7" testid="admin-rewards-earned" />
            <Stat label="Total redeemed" value={`${data.summary.total_redeemed.toLocaleString('en-IN')} pts`} icon={ArrowUpRight} color="#6B7280" bg="#F3F4F6" testid="admin-rewards-redeemed" />
            <Stat label="Outstanding" value={`${data.summary.outstanding_points.toLocaleString('en-IN')} pts`} icon={TrendingUp} color="#2E7D32" bg="#E8F5E9" testid="admin-rewards-outstanding" />
            <Stat label="Members" value={data.summary.members_count} icon={Award} color="#7B1FA2" bg="#F3E5F5" testid="admin-rewards-members" />
          </div>
          <div className="bg-white border border-neutral-200 rounded-2xl overflow-hidden" data-testid="admin-rewards-txn-table">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-neutral-50 border-b border-neutral-200 text-left">
                  <tr><Th>Date</Th><Th>User</Th><Th>Type</Th><Th>Reason</Th><Th>Order</Th><Th className="text-right">Points</Th></tr>
                </thead>
                <tbody>
                  {data.transactions.map((t) => (
                    <tr key={t.id} data-testid={`admin-reward-txn-${t.id}`} className="border-b border-neutral-100 hover:bg-neutral-50">
                      <td className="px-4 py-3 text-xs text-neutral-500 whitespace-nowrap">{new Date(t.created_at).toLocaleString('en-IN')}</td>
                      <td className="px-4 py-3">
                        <p className="font-semibold text-neutral-900">{t.user_name || '—'}</p>
                        <p className="text-xs text-neutral-500">{t.user_email}</p>
                      </td>
                      <td className="px-4 py-3">
                        <span className={`text-[11px] font-bold px-2 py-0.5 rounded uppercase ${t.type === 'earn' ? 'bg-[#FEF3C7] text-[#D97706]' : 'bg-neutral-100 text-neutral-500'}`}>{t.type}</span>
                      </td>
                      <td className="px-4 py-3 text-neutral-600 text-xs">{t.reason}</td>
                      <td className="px-4 py-3 text-neutral-500 text-xs font-mono">{t.order_id || '—'}</td>
                      <td className={`px-4 py-3 text-right font-bold ${t.type === 'earn' ? 'text-[#D97706]' : 'text-neutral-500'}`}>
                        {t.type === 'earn' ? '+' : '−'} {t.points}
                      </td>
                    </tr>
                  ))}
                  {data.transactions.length === 0 && <tr><td colSpan="6" className="text-center text-neutral-500 py-8">No reward activity yet</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
          <p className="mt-3 text-[11px] text-neutral-500 flex items-center gap-1"><ShieldCheck className="w-3 h-3 text-[#2E7D32]" /> Reading from shared collections: rewards, reward_transactions.</p>
        </>
      )}
    </AdminLayout>
  );
};
const Stat = ({ label, value, icon: Icon, color, bg, testid }) => (
  <div data-testid={testid} className="bg-white border border-neutral-200 rounded-xl p-4">
    <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: bg }}>
      <Icon className="w-5 h-5" style={{ color }} />
    </div>
    <p className="mt-3 text-xs text-neutral-500 font-medium">{label}</p>
    <p className="font-extrabold text-xl mt-0.5">{value}</p>
  </div>
);
const Th = ({ children, className = '' }) => <th className={`px-4 py-2.5 text-xs font-bold text-neutral-500 uppercase tracking-wider ${className}`}>{children}</th>;

export default AdminRewards;
